import { Box, Tab } from '@mui/material';
import { useState } from 'react';
import { News } from '../../../../types/news';
import { getCurrentDayLabel, groupNewsByDays } from './helper';
import { NewsTabPanel } from './NewsTabPanel';
import { DAY_LABELS } from './types';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { homeNewsStyles } from './styles';

interface NewsTabsProps {
  news: News[];
}

export const NewsTabs: React.FC<NewsTabsProps> = ({ news }) => {
  const [currentTab, setCurrentTab] = useState<typeof DAY_LABELS[number]>(getCurrentDayLabel());
  const groupedNewsByDays = groupNewsByDays(news);
  return (
    <Box>
      <TabContext value={currentTab}>
        <Box sx={homeNewsStyles.tabContainer}>
          <TabList sx={{ minHeight: '2rem' }} onChange={(_event, value) => setCurrentTab(value)} aria-label="News Tab">
            {DAY_LABELS.map((day) => (
              <Tab sx={homeNewsStyles.dayTab} key={day} value={day} label={day} />
            ))}
          </TabList>
        </Box>
        {groupedNewsByDays.map(({ day, news }) => (
          <TabPanel sx={{ px: 0 }} value={day} key={day}>
            <NewsTabPanel news={news} />
          </TabPanel>
        ))}
      </TabContext>
    </Box>
  );
};
